import { z } from 'zod'

export const SingleTicketGroupDtoSchema = z.union([z.literal('adult'), z.literal('child'), z.literal('universal')])

export type SingleTicketGroupDto = z.infer<typeof SingleTicketGroupDtoSchema>
